<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('village.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('village.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-panel>
      <ts-panel-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
							v-tooltip="$t('village.search')"
              :placeholder="$t('village.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-panel-wrapper>
      <ts-table
        :columns="columns"
        :records="villageResources"
        :loading="loading"
      >
        <template v-slot="{ record }">
          <td>{{ record.p_name_kh }}</td>
          <td>{{ record.d_name_kh }}</td>
          <td>{{ record.d_name_en }}</td>
          <td>{{ record.commune_code }}</td>
          <td>{{ record.c_name_kh }}</td>
          <td>{{ record.c_name_en }}</td>
          <td class="ts-text-blue-500">{{ record.village_code }}</td>
          <td class="ts-text-blue-500">{{ record.name_kh }}</td>
          <td class="ts-text-blue-500">{{ record.name_en }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="villagePaginate"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="!isUpdate ? $t('addNew') : $t('update')"
      :centered="true"
      @cancel="onCancel"
      :footer="null"
    >
      <VillageForm :record="record" @cancel="onCancel" />
    </a-modal>
  </div>
</template>

<script>
import { debounce, isEmpty } from 'lodash'
import { mapState } from 'vuex'
import VillageForm from './components/village-form.vue'
export default {
  name: 'branchIndex',
  components: {
    VillageForm
  },
  data() {
    return {
      loading: false,
      show_form: false,
      record: {}
    }
  },
  computed: {
    ...mapState('corporate/address', ['villageResources', 'villagePaginate']),

    isUpdate() {
      return !isEmpty(this.record)
    },
    search: {
      get() {
        return this.$store.state.corporate.address.search
      },
      set(newValue) {
        this.$store.commit('corporate/address/SET_SEARCH', newValue)
        this.$store.commit('corporate/address/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('village.provinceNameKh') },
        { name: this.$t('village.districtNameKh') },
        { name: this.$t('village.districtNameEn') },
        { name: this.$t('village.communeCode') },
        { name: this.$t('village.communeNameKh') },
        { name: this.$t('village.communeNameEn') },
        { name: this.$t('village.villageCode') },
        { name: this.$t('village.nameKh') },
        { name: this.$t('village.nameEn') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('corporate/address/villageFetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.show_form = true
    },
    edit(record) {
      this.record = record
      this.show_form = true
    },
    onCancel() {
      this.show_form = false
      this.record = {}
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('corporate/address/RESET_STATE')
    next()
  }
}
</script>
